import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import SelectField from 'modules/core/components/SelectField'
import Sidepanel from 'modules/core/components/Sidepanel'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import Loading from 'modules/finance/components/Loading'

import useEditDimensionValue from './useEditDimensionValue'

interface Props {
  value_id: number
  onClose: (success?: boolean) => void
}

const EditDimensionValueSidepanel = ({ value_id, onClose }: Props) => {
  const { loading, saving, form, hasErrors } = useEditDimensionValue(Number(value_id), onClose)

  const handleCancel = () => onClose()

  return (
    <Sidepanel
      overlay={false}
      boxPadding={false}
      width="narrow"
      title={i18n.t('finance.dimension_detail.sidepanel.title')}
      onClose={onClose}
      headerBorder
      open
      closeLabel={i18n.t('common.close')}
      footer={
        form.dirty && (
          <>
            <Button type="secondary" onClick={handleCancel}>
              {i18n.t('finance.dimension_detail.sidepanel.cancel')}
            </Button>
            <Button
              onClick={() => form.handleSubmit()}
              disabled={!form.dirty || hasErrors || saving}
            >
              {i18n.t('finance.dimension_detail.sidepanel.save')}
            </Button>
          </>
        )
      }
    >
      <Loading loading={loading}>
        <Box padding="s24" paddingBottom="s12">
          <TextField
            mandatory
            label={i18n.t('finance.dimension_detail.sidepanel.name')}
            value={form.values.name}
            onChange={(value) => form.setValues({ ...form.values, name: value })}
            error={form.errors.name}
          />
        </Box>
        <Box padding="s24" paddingBottom="s12">
          <TextField
            label={i18n.t('finance.dimension_detail.sidepanel.code')}
            value={form.values.code}
            onChange={(value) => form.setValues({ ...form.values, code: value })}
            error={form.errors.code}
            secondaryLabel={
              <InformationTooltip
                information={i18n.t('finance.modals.add_cost_center.fields.code.information')}
                icon="question"
              />
            }
          />
        </Box>
        <Box padding="s24" paddingBottom="s12">
          <TextField
            label={i18n.t('finance.dimension_detail.sidepanel.description')}
            value={form.values.description}
            onChange={(value) => form.setValues({ ...form.values, description: value })}
            error={form.errors.description}
          />
        </Box>
        <Box padding="s24" paddingBottom="s12">
          <SelectField
            label={i18n.t('finance.dimension_detail.sidepanel.legal_entity')}
            options={[
              {
                label:
                  form.values.legalEntityName ||
                  i18n.t('finance.dimension_detail.table.all_legal_entities'),
                value: '',
              },
            ]}
            readonly
          />
        </Box>
        <Box padding="s24" paddingTop="s12">
          <Box padding="s16" background="grey200" borderRadius={{ all: 'abs008' }}>
            <Text.Normal>
              {i18n.t('finance.dimension_detail.sidepanel.readonly_legal_entity')}
            </Text.Normal>
          </Box>
        </Box>
      </Loading>
    </Sidepanel>
  )
}

export default observer(EditDimensionValueSidepanel)
